<template>
  <div class="mb-5">
    <div
      class="strategies"
      v-for="stage in stages"
      :key="stage.id">

      <div class="strategy-title">
        {{stage.title}}
        ({{formatDate(stage.dateFrom, 'y-m-d')}} - {{formatDate(stage.dateTo, 'y-m-d')}})
      </div>

      <div class="goals">
        <div
          class="goals-item"
          v-for="goal in stage.goals"
          :key="goal.id">
          <div
            v-if="['achieved', 'canceled'].includes(goal.status)"
            :class="`d-inline-block mr-2 status-${goal.status}`">
            <i v-if="goal.status === 'achieved'" class="fas fa-check"></i>
            <i v-else-if="goal.status === 'canceled'" class="fas fa-times"></i>
          </div>

          {{goal.strategy}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../utils/formatDate';

export default {
  name: 'StrategyList',

  props: ['stages'],

  data() {
    return {};
  },

  methods: {
    formatDate(dateString, format) {
      return formatDate(new Date(dateString), format);
    }
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/variables.scss";

.strategies {
  .strategy-title {
    position: relative;
    padding: 10px 0 10px 20px;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    color: $primary;
    background-color: $light-gray-bg;
    border-top: 2px solid $primary;
  }

  .goals {
    .goals-item {
      padding: 15px 20px;
      font-weight: normal;
      font-size: 14px;
      border-top: 1px solid $light-gray;

      &:first-of-type {
        border-top: 0;
      }

      .status-achieved {
        color: $green;
      }

      .status-canceled {
        color: $red;
      }
    }
  }
}
</style>
